import { useMemo } from 'react'
import { useAuth } from '../context/AuthContext'

type StoreInfo = {
  id?: string
  name?: string
  humpClubStoreCode?: string
}

type ReportingUser = {
  id: string
  email?: string
  name?: string
  role?: string
  restrictedToRegions?: string[]
  store?: StoreInfo | null
}

export const getReportingUserDisplayName = (
  payload: Record<string, unknown> | null,
): string | null => {
  if (!payload || typeof payload !== 'object') {
    return null
  }

  const { name, firstName, lastName, email } = payload as {
    name?: string
    firstName?: string
    lastName?: string
    email?: string
  }

  if (typeof name === 'string' && name.trim()) {
    return name.trim()
  }

  const fullName = [firstName, lastName].filter(Boolean).join(' ').trim()
  if (fullName) {
    return fullName
  }

  if (typeof email === 'string' && email.trim()) {
    return email.trim()
  }

  return null
}

export const useReportingUser = (): ReportingUser | null => {
  const { payload } = useAuth()

  return useMemo(() => {
    if (!payload || typeof payload !== 'object') return null

    const { id, email, role, restrictedToRegions, store } = payload as any

    if (!id) return null

    return {
      id,
      email,
      name: getReportingUserDisplayName(payload) ?? undefined,
      role,
      restrictedToRegions: Array.isArray(restrictedToRegions) ? restrictedToRegions : undefined,
      store: store
        ? {
            id: store.id,
            name: store.name,
            humpClubStoreCode: store.humpClubStoreCode,
          }
        : null,
    }
  }, [payload])
}
